import { Modal, useToast } from "@nabble/ui";
import { useState } from "react";
import { confirmTotpEnrollment, startTotpEnrollment } from "../../../../api/secondFactors";
import { TotpSetup } from "../../../../components/TotpSetup";
import { errorMessage } from "../../../../errors";

/** Links an authenticator app: scan the QR code, then confirm with its first code. */
export function SetUpTotpDialog({ onClose, onDone }: { onClose: () => void; onDone: () => void }): React.JSX.Element {
  const { show } = useToast();
  const [error, setError] = useState<string | null>(null);

  async function confirm(code: string): Promise<void> {
    setError(null);
    try {
      await confirmTotpEnrollment(code);
      show({ title: "Authenticator app set up", tone: "success" });
      onDone();
    } catch (err) {
      setError(errorMessage(err, "Wrong code."));
    }
  }

  return (
    <Modal
      open
      icon="smartphone"
      title="Set up authenticator app"
      description="Scan the code with your app and confirm with the first code it shows."
      onClose={onClose}
    >
      <TotpSetup
        start={startTotpEnrollment}
        error={error}
        onStartError={(err) => setError(errorMessage(err, "We couldn't start the setup."))}
        confirm={confirm}
      />
    </Modal>
  );
}
